import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  isFocus: false,
  optional: false,
};

const propTypes = {
  label: PropTypes.node.isRequired,
  isFocus: PropTypes.bool,
  optional: PropTypes.bool,
};

export default function FormLabel({
  label,
  isFocus,
  optional,
}) {
  return (
    <div
      className={clsx(
        'leading-normal text-base flex w-full items-center space-x-2 font-normal',
        isFocus === false && 'text-gray-700',
        isFocus && 'text-gray-900',
      )}>
      <div className="font-medium">
        {label}
      </div>
      {optional && (
        <div className="text-sm">
          (opcional)
        </div>
      )}
    </div>
  );
}

FormLabel.defaultProps = defaultProps;
FormLabel.propTypes = propTypes;
